import { LANGUAGES } from '../constants';

export default (lng) => {
  const language = LANGUAGES.find((item) => item.language === lng);
  return language ? language.icon : null;
};
